import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CFDocumentFile } from '../../models/cf-document/cf-document-file';
import { CFDocumentResendPin } from '../../models/cf-document/cf-document-resend-pin';
import { CFDocumentToDisplay } from '../../models/cf-document/cf-document-to-display';
import { KeyValuePairEnum } from '../../models/key-value-pair-enum';

@Injectable({ providedIn: 'root' })
export class CFDocumentService {
    private apiUrl = environment.apiUrl + '/api/documents';
    constructor(private http: HttpClient) {}

    getDocument(documentType: number, companyId: string, documentNumber: string): Observable<CFDocumentToDisplay> {
        return this.http.get<CFDocumentToDisplay>(`${this.apiUrl}/${documentType}/${companyId}/${documentNumber}`);
    }

    getDocumentById(cloudFlowDocumentId: string): Observable<CFDocumentToDisplay> {
        return this.http.get<CFDocumentToDisplay>(`${this.apiUrl}/${cloudFlowDocumentId}`);
    }

    getDocumentTypes(): Observable<Array<KeyValuePairEnum>> {
        return this.http.get<Array<KeyValuePairEnum>>(`${this.apiUrl}/document-types`);
    }

    getDocumentVersions(documentType: number, companyId: string, externalId: string): Observable<Array<CFDocumentFile>> {
        return this.http.get<Array<CFDocumentFile>>(`${this.apiUrl}/${documentType}/${companyId}/${externalId}/versions`);
    }

    resendPin(cloudFlowId: string, resendPinCode: CFDocumentResendPin): Observable<any> {
        return this.http.patch(`${this.apiUrl}/${cloudFlowId}/resend-pin`, resendPinCode);
    }

    downloadLatestDocument(documentType: number, companyId: string, externalId: string): Observable<Blob> {
        return this.http.get(`${this.apiUrl}/${documentType}/${companyId}/${externalId}/latest`, {
            responseType: 'blob'
        });
    }
}
